module.exports = __webpack_public_path__ + "img/08.ea55328.png";